export default function(app) {

    $('.widget a.copy').click(function(e) {
        e.preventDefault()

        const $this = $(this)
        $this.addClass('copied')

        let text = ''
        $($this.data('target')).each(function(index, el){
            if(el.value)        text += el.value
            if(el.innerText)    text += el.innerText
        })
        copyToClipboard(text)

        setTimeout(()=>{
            $this.removeClass('copied')
        },1000)

        return false
    })

    function copyToClipboard(str) {
        const el = document.createElement('textarea');
        el.value = str;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }

}
